import React from 'react';
import { Box, Rating, Typography, LinearProgress } from '@mui/material';
import type { JoinedSparks } from 'types/Spark/JoinedSpark';

type RatingListProps = {
  spark: JoinedSparks | undefined;
};

function RatingList({ spark }: RatingListProps) {
  const sparkMeta = spark?.meta;
  const sparkAverageRating = sparkMeta?.averageRating ?? 0;
  const totalRatingsGiven = sparkMeta?.numberOfRatings ?? 0;
  const ratingDistribution = sparkMeta?.ratingDistribution;

  return (
    <Box mb={1} p={'8px'} display={'flex'} alignItems={'flex-start'}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'flex-start'}
      >
        <Typography
          variant='h2'
          lineHeight={0.9}
          sx={{ color: (theme) => theme.palette.primary.main }}
        >
          {sparkAverageRating.toString().padEnd(3, '.0')}
        </Typography>
        <Rating
          value={sparkAverageRating}
          precision={0.1}
          max={5}
          size='small'
          readOnly={true}
        />
        <Typography variant='body2' ml={0.5}>
          {totalRatingsGiven} review{totalRatingsGiven > 1 ? 's' : ''}
        </Typography>
      </Box>
      <Box
        display={'flex'}
        flexGrow={1}
        flexDirection={'column-reverse'}
        justifyContent={'space-between'}
        p={'0px 10px 10px 0px'}
        marginLeft={1}
      >
        {ratingDistribution &&
          Object.entries(ratingDistribution).map(
            ([ratingNumber, ratingValue], index) => {
              const ratingPercentage = totalRatingsGiven
                ? Math.floor((ratingValue / totalRatingsGiven) * 100)
                : 0;

              return (
                <Box
                  key={index}
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  width={'100%'}
                >
                  <Typography
                    variant='body2'
                    minWidth={'8px'}
                    textAlign={'center'}
                  >
                    {ratingNumber}
                  </Typography>
                  <LinearProgress
                    variant='determinate'
                    value={ratingPercentage}
                    sx={{
                      height: 10,
                      borderRadius: 15,
                      width: '100%',
                      marginLeft: '0.5em',
                      flex: 1,
                    }}
                  />
                </Box>
              );
            }
          )}
      </Box>
    </Box>
  );
}

export default RatingList;
